import { writable } from 'svelte/store';
/**
 * This function generates a UUID in the format xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx when crypto.randomUUID is not available.
 * For example, in older browsers or environments where crypto is not supported and/or safari browsers.
 * **/
export function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
const createToastStore = () => {
    const { subscribe, update } = writable([]);
    const DEFAULT_DURATION = 10000;
    const addToast = (toast) => {
        const id = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : generateUUID();
        const duration = toast.duration ?? DEFAULT_DURATION;
        update((toasts) => [...toasts, { id, ...toast, duration }]);
        if (duration > 0) {
            setTimeout(() => removeToast(id), duration);
        }
    };
    const removeToast = (id) => {
        update((toasts) => toasts.filter((toast) => toast.id !== id));
    };
    return {
        subscribe,
        addToast,
        removeToast
    };
};
export const toastStore = createToastStore();
